// 放多租户和全局类的工具钩子
import { computed } from 'vue'
import { useStoreHooks } from '@/store/hook'
import { useRoute } from 'vue-router'
import { TENANT_ID_MAP, CookieUtil } from '@/utils'
import { CERTIFICATION_TYPE } from '@/utils/config'
import { getRelatedCerByCountryLanguage } from '@/request/api/certification'
import { useClientCompatibleHook } from '@/utils/hooks'

const checkIsCertificationPage = (path: string) => {
  const reg = /^\/certification\/detail\/[0-9]+$/
  return reg.test(path)
}

const checkIsCoursePage = (path: string) => {
  const reg = /^\/course\/detail\/[0-9]+$/
  return reg.test(path)
}

export function useTenantCertificationUrlHook () {
  const store = useStoreHooks()
  const tenantId = computed(() => store.state.global.tenantId)
  const certificationTypes = computed(() => store.state.global.certificationTypes)
  // const certificationTypes = store.state.global.certificationTypes
  const hscKind = certificationTypes.value.find(item => item.kindType === CERTIFICATION_TYPE.hsc)
  const gscKind = certificationTypes.value.find(item => item.kindType === CERTIFICATION_TYPE.gsc)

  const replaceSpaces = (str: string) => {
    const reg = /\s+/g
    return str.replace(reg, '-').toLowerCase()
  }
  const URL_MAP = {
    // 海康用单独规则
    [TENANT_ID_MAP.hikvision]: {
      hsc: {
        overview: '/hikvision-security-certification/overview',
        classroomList: '/hikvision-security-certification/classroom',
        courseList: '/hikvision-security-certification/online-video-courses'
      },
      gsc: {
        overview: '/general-security-certification/overview',
        classroomList: '/general-security-certification/classroom',
        courseList: '/general-security-certification/online-video-courses'
      }
    },
    // 其他租户都用这个规则
    default: {
      hsc: {
        overview: `/overview/${replaceSpaces(hscKind?.kindName || '')}`,
        classroomList: `/classroom/${replaceSpaces(hscKind?.kindName || '')}`,
        courseList: `/online-video-courses/${replaceSpaces(hscKind?.kindName || '')}`
      },
      gsc: {
        overview: `/overview/${replaceSpaces(gscKind?.kindName || '')}`,
        classroomList: `/classroom/${replaceSpaces(gscKind?.kindName || '')}`,
        courseList: `/online-video-courses/${replaceSpaces(gscKind?.kindName || '')}`
      }
    }
  }
  return {
    URL_MAP: tenantId.value === TENANT_ID_MAP.hikvision ? URL_MAP[TENANT_ID_MAP.hikvision] : URL_MAP.default
  }
}

export function useHeaderHook () {
  const { state: storeState } = useStoreHooks()
  const { push } = useClientCompatibleHook()
  // const router = useRouter()
  const route = useRoute()
  const tenantId = computed(() => storeState.global.tenantId)
  const certificationTypes = computed(() => storeState.global.certificationTypes)
  const toPage = (path: string) => {
    push(path)
  }
  const replaceSpaces = (str: string) => {
    const reg = /\s+/g
    return str.replace(reg, '-').toLowerCase()
  }
  const toCertificationPage = (kind: string, target: string) => {
    const certificationType = certificationTypes.value.find(item => item.kindType === kind)
    if (!certificationType) return
    const path = replaceSpaces(certificationType.kindName)
    if (tenantId.value === TENANT_ID_MAP.hikvision) {
      toPage(`/${path}/${target}`)
    } else {
      toPage(`/${target}/${path}`)
    }
  }
  // 检查用户ip和所选语言是否一致
  const checkIpAndLanguage = () => {
    const currentLangItem = storeState.global.languageList.find(item => {
      return item.id === storeState.global.currentLangKey
    })
    return currentLangItem?.countryCode !== storeState.global.isoCode
  }
  const getLanguageSelectorVisible = () => {
    if (storeState.global.languageList.length <= 1) {
      // 如果站点下只配置了一个语言，则不跳弹窗
      return false
    }
    const languageCheckedId = CookieUtil.getCookie('languageCheckedId')
    const showCountryLanguageTips = CookieUtil.getCookie('showCountryLanguageTips')
    const languageVisible = languageCheckedId ? false : checkIpAndLanguage()
    return languageVisible && !showCountryLanguageTips
  }

  const getRelatedCertificationInfo = (langId: string | number) => {
    const path = route.path
    if (checkIsCertificationPage(path)) {
      const detailData = computed(() => storeState.certification.detail.certificationDetail)
      getRelatedCerByCountryLanguage({
        releaseCertificationId: detailData.value?.id,
        languageId: langId
      }).then(res => {
        const data = res.data as Array<{ id: number }>
        if (res.code === 200 && data && data.length === 1) {
          // todo
          location.href = `/${window.prefix}/certification/detail/${data[0].id}`
        } else {
          location.href = `/${window.prefix}/`
        }
      })
    } else if (checkIsCoursePage(path)) {
      const courseDetail = computed(() => storeState.course.detail.courseDetail)
      getRelatedCerByCountryLanguage({
        releaseCertificationId: courseDetail.value?.relationId,
        languageId: langId
      }).then(res => {
        const data = res.data as Array<{ id: number }>
        if (res.code === 200 && data && data.length === 1) {
          // todo
          location.href = `/${window.prefix}/certification/detail/${data[0].id}`
        } else {
          location.href = `/${window.prefix}/`
        }
      })
    } else {
      location.href = `/${window.prefix}/`
    }
  }
  return {
    toPage,
    toCertificationPage,
    getLanguageSelectorVisible,
    checkIsCertificationPage,
    checkIsCoursePage,
    getRelatedCertificationInfo,
    checkIpAndLanguage
  }
}
